const tab = {
  playlists: {
    label: '專案選曲',
    icon: 'playlists',
    routeName: 'my-music-playlists',
    i18nKey: 'myMusic.playlist',
    gtmClass: 'GTM_POINT_member_playlists',
  },
  'search-history': {
    label: '搜尋歷史',
    icon: 'search-history',
    routeName: 'my-music-search-history',
    i18nKey: 'myMusic.searchHistory',
    gtmClass: 'GTM_POINT_member_search-history',
  },
  'play-history': {
    label: '播放紀錄',
    icon: 'play-history',
    routeName: 'my-music-play-history',
    i18nKey: 'myMusic.playedHistory',
    gtmClass: 'GTM_POINT_member_play-history',
  },
  'download-history': {
    label: '下載紀錄',
    icon: 'download-history',
    routeName: 'my-music-download-history',
    i18nKey: 'myMusic.downloadHistory',
    gtmClass: 'GTM_POINT_member_download-history',
  },
  'my-note': {
    label: '我的筆記',
    icon: 'my-note',
    routeName: 'my-music-my-note',
    i18nKey: 'myMusic.myNote',
    gtmClass: 'GTM_POINT_member_my-note',
  },
  'preview-tool': {
    label: '影音結合體會',
    icon: 'preview-tool',
    routeName: 'my-music-preview-tool',
    i18nKey: 'myMusic.previewTool',
    gtmClass: 'GTM_POINT_member_preview-tool',
  },
};

export const mobileTabs = [
  tab.playlists,
  tab['my-note'],
];

export const pcTabs = [
  tab.playlists,
  tab['search-history'],
  tab['play-history'],
  tab['download-history'],
  tab['my-note'],
];

export const pcTabsWithFullFunctions = [
  tab.playlists,
  tab['search-history'],
  tab['play-history'],
  tab['download-history'],
  tab['my-note'],
  tab['preview-tool'],
];
